import React from 'react';
import { useTranslation } from 'react-i18next';
import CustomCard from "../CustomCard";
import RowCardText from "../RowCardText";
/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */

const ErrorCard = ({ numero, row, column, error, value }) => {
    const { t } = useTranslation();

    return (
        <div className='col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4 mb-4'>
            <CustomCard>
                <RowCardText title={t('N°')} value={numero || '-'} />
                <RowCardText title={t('ROW')} value={row || '-'} />
                <RowCardText title={t('COLUMN')} value={column || '-'} />
                <RowCardText title={t('value')} value={value || '-'} />
                <RowCardText title={t('DESCRIPTION')} value={error || '-'} tooltip={error}/>
            </CustomCard>
        </div>
    );
};

export default ErrorCard;
